import React, { useMemo, useCallback } from 'react';
import { mergeStyles, getRelValue } from 'wix-rich-content-common';
import { S as Styles } from '../default-styles-74c82233.js';
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from '../types.js';
import '../style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ButtonViewer = ({
  style,
  anchorTarget,
  onClick,
  theme,
  helpers,
  url,
  target = anchorTarget,
  rel,
  buttonText
}) => {
  const styles = mergeStyles({ styles: Styles, theme });
  const isActionButton = useMemo(() => Boolean(onClick), [onClick]);
  const onClickHandler = useCallback(
    (args) => {
      var _a;
      (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, isActionButton ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE, "Click", "");
      if (isActionButton) {
        onClick == null ? void 0 : onClick(args);
      }
    },
    [helpers.onViewerAction]
  );
  const Component = isActionButton ? "div" : "a";
  return /* @__PURE__ */ React.createElement(
    Component,
    __spreadValues({
      className: styles.button_container,
      style,
      "data-hook": "buttonViewer",
      onClick: onClickHandler,
      tabIndex: 0,
      role: "button",
      onKeyDown: (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onClickHandler(e);
        }
      }
    }, !isActionButton && { href: url, target, rel: getRelValue(rel) }),
    /* @__PURE__ */ React.createElement("div", { className: styles.button_text }, buttonText)
  );
};

export { ButtonViewer as default };
//# sourceMappingURL=button-viewer.js.map
